import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { COMPARE_PRICE, PRICE, PRODUCT_IMAGE, offerIncludes, offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-228" data-mp="1mm7j0vzbjbew">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-229" data-mp="1hoxudijr73s4">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-230" data-mp="tzwjzprd1ik7">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-231" data-mp="ozrzlonc03op">
            Objevte kompletní balíček <em className="text-red-300" data-id="element-232" data-mp="13xkdkcd8ck0s">VÝTVARKA HOTOVÁ™</em>
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-233" data-mp="yxxydxductpc">
            Celý školní rok výtvarné výchovy – hotový. Za 5 minut připraveni do hodiny.
          </p>
          <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-234" data-mp="2feana5gv3tz5" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-235" data-mp="pkh3z3r2mici">
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-236" data-mp="uhqw4r5uh841">Kompletní balíček obsahuje</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-237" data-mp="ziwm4h84eh9v">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-238" data-mp="13j71ullpsm1x">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-239" data-mp="6use3p22ts40">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-240" data-mp="btc2dw457fzj" />
                </span>
                <span data-id="element-241" data-mp="fsb3t6qo0um8">
                  <span className="block font-medium leading-snug" data-id="element-242" data-mp="kl49pxxve8zw">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-243" data-mp="kmywziwm6d75">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-244" data-mp="3o8wfwwelg3tk">
            <p className="text-sm font-medium text-slate-900/70 sm:pb-2" data-id="element-245" data-mp="qgnr8ff7p2j6">Úvodní cena</p>
            <p className="font-serif text-7xl leading-none tracking-tight text-slate-900 sm:text-8xl" data-id="element-246" data-mp="qetg1stqsosa">
              <s className="mr-3 align-middle text-3xl text-slate-900/40 sm:text-4xl" data-id="element-247" data-mp="157d3ll4esnom"><span className="sr-only" data-id="element-248" data-mp="106z3qqcyok1o">Původně </span>{COMPARE_PRICE}</s>
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-249" data-mp="cipoy8e60wk1">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-250" data-mp="lhkt7exnfwkp" />
            Jednorázová platba. Žádné předplatné.
          </p>

          <CtaButton label="Objednat kompletní balíček" className="mt-8 w-full" data-id="element-251" data-mp="hewl59gretos" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-252" data-mp="1ww6rm511z58r">
            {offerIncludes.map(item => <li key={item} data-id="element-253" data-mp="1sucycht6t3im">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}